// Short request-id generator for the API client.
// See react-rewrite-plan.md sections 6.5 and 11.3 api-client.
//
// The id is attached as the X-Request-Id header so backend logs and frontend
// logs can be correlated. 8 hex chars is plenty for correlation within a
// single user session.

const ID_LENGTH = 8;

export function newRequestId(): string {
  const cryptoObj = (globalThis as { crypto?: Crypto }).crypto;
  if (cryptoObj && typeof cryptoObj.randomUUID === 'function') {
    return cryptoObj.randomUUID().replace(/-/g, '').slice(0, ID_LENGTH);
  }
  // Math.random fallback for environments without crypto (e.g. very old
  // jsdom). Not used for cryptographic purposes; ids only need to be
  // unique-enough for log correlation.
  return Math.random().toString(16).slice(2, 2 + ID_LENGTH).padEnd(ID_LENGTH, '0');
}
